export const INSUFFICIENT_HINT_BALANCE_MESSAGE = 'Gettoncini insufficienti per questo aiutino.';

export const canAffordHintCost = ({ cost, balance, isPreview = false, isFree = false }) => {
  if (isPreview || isFree) return true;
  if (typeof cost !== 'number' || typeof balance !== 'number') return true;
  return balance >= cost;
};

export const getScalinataHintErrorMessage = (response) => {
  if (response?.error === 'INSUFFICIENT_BALANCE') {
    return INSUFFICIENT_HINT_BALANCE_MESSAGE;
  }
  if (response?.error === 'ALREADY_USED') {
    return 'Aiutino gia usato';
  }
  return response?.message || 'Errore durante la richiesta';
};
